import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { AcademyInUseRequest } from "./AcademyInUseRequest";
import { AddAcademyRequest } from "./AddAcademyRequest";
import { EditAcademyRequest } from "./EditAcademyRequest";

@Injectable()
export class DataService_AcademySetup {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	LoadAcademy(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/LoadAcademy?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadStaff(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/LoadStaff?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AcademyNameInUse(parms: AcademyInUseRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/AcademyNameInUse";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AcademyCDInUse(parms: AcademyInUseRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/AcademyCDInUse";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AddAcademy(parms: AddAcademyRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/AddAcademy";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	EditAcademy(parms: EditAcademyRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/EditAcademy";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DeleteAcademy(AcademyID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/DeleteAcademy?AcademyID=" + AcademyID;
		var promise$ = this.httpclientService.post(url, null);

		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
